import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import banner from "./../../images/banner.png"
import { Link } from 'react-router-dom'

const DiscountCard = () => {
    return (
        <Link to="/shopproduct">
            <img className="w-100" src={banner} alt="" />
        </Link>
    )
}

export default DiscountCard
